/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_viewer$ref = any;
export type PdpSharedDealerDetailsHeader_viewer = {
    readonly isNewSellerPillEnabled: boolean | null;
    readonly " $refType": PdpSharedDealerDetailsHeader_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDealerDetailsHeader_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isNewSellerPillEnabled",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "enableNewSellerPill"
                }
            ],
            "storageKey": "isEnabled(key:\"enableNewSellerPill\")"
        }
    ]
} as any);
(node as any).hash = '7274bd88ebf0a9f442896c44aa0931c5';
export default node;
